<template>
  <b-modal
    v-model="showModal"
    title="Előfizetés részletei"
    ok-title="Bezárás"
    ok-variant="info"
    :ok-only="true"
    size="lg"
    scrollable
  >
    <loading v-model="loading" :height="500">
      <div class="section">
        <div class="section-title">
          <h5><span class="badge mr-2" :class="`badge-${state.variant}`">#{{subscriptionId}}</span>Előfizetés</h5>
        </div>
        <div class="section-content">
          <b-container class="px-0">
            <b-row class="py-2">
              <b-col>Állapot</b-col>
              <b-col>
                <b-dropdown :text="state.text" :variant="state.variant" size="sm" right>
                  <b-dropdown-item-button
                    v-for="(currentState, index) in states"
                    :key="`st${index}`"
                    :active="currentState.value === state.value"
                    @click="setState(currentState)"
                  >
                    {{ currentState.text }}
                  </b-dropdown-item-button>
                </b-dropdown>
              </b-col>
            </b-row>
            <b-row class="py-2" v-if="subscription.customer">
              <b-col>Ügyfél</b-col>
              <b-col>
                <span v-if="subscription.customer">
                  <span>{{ subscription.customer.name }}</span>
                  <span class="badge badge-info ml-2 fs-90" v-if="subscription.customer.price_discount > 0">
                    {{subscription.customer.price_discount * 100}}% kedvezmény
                  </span>
                </span>
                <span v-if="!subscription.customer">Törölt ügyfél</span>
              </b-col>
            </b-row>
            <b-row class="py-2">
              <b-col>Csomag</b-col>
              <b-col>
                <toggle-details :label="subscription.package.name" v-b-toggle.package-details></toggle-details>
              </b-col>
            </b-row>
            <b-collapse id="package-details">
              <b-row class="py-2">
                <b-col>
                  <package :selected-package="subscription.package"></package>
                </b-col>
              </b-row>
            </b-collapse>
            <b-row class="py-2">
              <b-col>Létrehozva</b-col>
              <b-col>{{ displayFormatDate(subscription.created_at) }}</b-col>
            </b-row>
            <b-row class="py-2 border-top">
              <b-col>Előfizetés vége</b-col>
              <b-col>{{ displayFormatDate(subscription.schedule_end) }}</b-col>
            </b-row>
            <b-row class="py-2">
              <b-col>Következő fizetés esedékes</b-col>
              <b-col>{{ displayFormatDate(subscription.schedule_next_payment) }}</b-col>
            </b-row>
            <b-row class="py-2 border-top">
              <b-col>Próbaidőszak</b-col>
              <b-col><b-checkbox v-model="subscription.is_trial" disabled></b-checkbox></b-col>
            </b-row>
            <b-row class="py-2" v-if="subscription.is_trial">
              <b-col>Próbaidőszak vége</b-col>
              <b-col>{{ displayFormatDate(subscription.schedule_end_trial) }}</b-col>
            </b-row>
            <b-row class="py-2" v-if="subscription.is_trial">
              <b-col>Próbaidőszak kedvezmény</b-col>
              <b-col>{{ subscription.package.trial_discount * 100 }} %</b-col>
            </b-row>
          </b-container>
        </div>
      </div>
      <div class="section">
        <div class="section-title">
          <h5>Kapcsolódó vásárlások</h5>
        </div>
        <div class="section-content">
          <purchases-table
            :subscription-id="subscriptionId"
            :hidden-columns="['package', 'subscription_link']"
          ></purchases-table>
        </div>
      </div>
    </loading>
  </b-modal>
</template>
<script>
import moment from 'moment'
import datePickerLabels from '../common/_datePickerLabels'
import { displayFormatDate } from '../../utils/Date'

import FormValidation from '../../utils/mixins/FormValidation'
import ErrorHandler from '../../utils/mixins/ErrorHandler'

import Loading from '../common/LoadingPlaceholder'

import emptyCustomer from '../customer/_customer'
import Package from '../packages/Package'
import emptyPackage from '../packages/_package'
import ToggleDetails from '../common/ToggleDetails.vue'


import { getSubscriptionState, subscriptionStates } from './_subscription'
import emptySubscription from './_subscription'

export default {
  mixins: [
    ErrorHandler()
  ],
  components: {
    'package': Package,
    'loading': Loading,
    'toggle-details': ToggleDetails
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    subscriptionId: {
      type: Number,
      required: true
    },
    subscriptions: {
      type: Array,
      required: false,
      default: () => ([])
    }
  },
  data() {
    return {
      subscription: emptySubscription,
      loading: true,
      showModal: false,
      states: subscriptionStates
    }
  },
  computed: {
    state() {
      return getSubscriptionState(this.subscription.state)
    }
  },
  watch: {
    showModal: function(show) {
      this.$emit('update:show', show)
    },
    show: {
      immediate: true,
      handler(show) {
        this.showModal = show

        if(!show) {
          return
        }

        if (this.subscriptions.length > 0) {
          var subscription = _.find(this.subscriptions, subscription => subscription.id === this.subscriptionId)
          if(typeof subscription !== 'undefined') {
            this.subscription = subscription
            this.loading = false
            return
          }
        }

        this.loadSubscription()
      },
    }
  },
  mounted() {
  },
  methods: {
    setState(state) {
      if (this.state.value === state.value) {
        return
      }

      const h = this.$createElement
      const messageVNode = h('div', { domProps: {
        innerHTML: `Biztosan át szeretnéd állítani a(z) #${this.subscriptionId} előfizetést
          <span class="fs-100 badge badge-${this.state.variant}">${this.state.text}</span>
          állapotúról
          <span class="fs-100 badge badge-${state.variant}">${state.text}</span> állapotúra?`
      } })

      this.$bvModal.msgBoxConfirm([messageVNode], {
        title: 'Megerősítés',
        okVariant: 'danger',
        okTitle: 'Igen',
        cancelTitle: 'Nem',
      }).then(value => {
        if(value) {
          this.loading = true

          this.$http.patch(this.$url('api.billing-subscriptions.update', this.subscriptionId), {
            ...this.subscription,
            state: state.value
          })
            .then(({data}) => {
              this.subscription = data.subscription

              this.$root.$emit('subscriptions-updated', { subscriptions: [data.subscription] })
            })
            .catch(this.handleErrors)
            .finally(() => this.loading = false)
        }
      })

    },
    loadSubscription() {
      this.loading = true

      this.$http.get(this.$url('api.billing-subscriptions.show', this.subscriptionId))
        .then(({data}) => {
          this.subscription = data.subscription
          this.loading = false
        })
        .catch(this.handleErrors)
    },
    displayFormatDate
  }
}
</script>